export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_LOADING = 'CREATE_PAYMENT_LOADING';
export const CREATE_PAYMENT_ERROR = 'CREATE_PAYMENT_ERROR';

export const AUTH_CALL_SUCCESS = 'AUTH_CALL_SUCCESS';
export const AUTH_CALL_LOADING = 'AUTH_CALL_LOADING';
export const AUTH_CALL_ERROR = 'AUTH_CALL_ERROR';

export const RESET_CREATE_PAYMENT_REDUCER = 'RESET_CREATE_PAYMENT_REDUCER';